import { Ref, useContext, useRouter } from '@nuxtjs/composition-api'
import { Route, VueRouter } from 'vue-router/types/router'
import { ProductPriceSensitiveData, UseProductSensitive } from './types'
import { ProductDetails, useProduct } from '~/modules/catalog/product/composables/useProduct'
import { Product } from '~/modules/catalog/product/types'

export function useProductSensitive (): UseProductSensitive {
  const { $vsf } = useContext()
  const { getProductDetails } = useProduct()
  const router = useRouter()

  async function loadProductPrices (sku: string): Promise<ProductPriceSensitiveData> {
    const result: ProductDetails = await getProductDetails({
      fetchPolicy: 'no-cache',
      filter: {
        sku: {
          eq: sku
        }
      }
    }, { productDetail: 'productDetailPriceTiers' })
    return (result?.items?.[0] as ProductPriceSensitiveData) || {
      price_tiers: [],
      price_range: null
    }
  }

  async function applyProductTierPrices (product: Ref<Product>): Promise<void> {
    // use referer field from @tozd/vue-router-referer plugin
    const referer = (router as VueRouter & { referer: Route }).referer
    // Load sensitive data only when we have an authorization token and
    // the current page is the entry point into the application (the first page viewed from ssr)
    if (product.value && !process.server && $vsf.$magento.config.state.getCustomerToken() && !referer?.name) {
      const productPrices = await loadProductPrices(product.value.sku)

      if (Array.isArray(productPrices.price_tiers) && productPrices.price_tiers.length) {
        product.value.price_tiers = productPrices.price_tiers
      }

      if (productPrices.price_range) {
        product.value.price_range = productPrices.price_range
      }
    }
  }

  return {
    loadProductPrices,
    applyProductTierPrices
  }
}
